import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campSovNew: FaireAdCampaignEntity = {
  token: "camp_sov_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_sweet_on_vermont",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 200,
  startedRunningAt: "2024-03-16",
  segmentMetrics: {
    numCustomersAcquired: 50,
    salesDollars: 24672,
    totalAdsSpendDollars: 3301,
    cpaDollars: 66.02,
    bestEstimateSalesDollars: 22655,
    bestEstimateRoas: 6.86,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
